module.exports = __webpack_public_path__ + "img/0Q3B0162_L_BlackMatted_MockedUp.be1819b3.jpg";